import React from 'react'
import style from "./greybox.module.css" 
const Greybox = () => {
  return (
   
          
    <div className={style.dia}>
<div className={style.tag}><br/> </div>
  <div className={style.los1}>
    <div className={style.img}>
    <img className={style.image}  alt="" />
    </div>
  </div>  </div>
  )
}

export default Greybox